export const applyPropertyArchiveState = (
  property: Property,
  archivedAt: string,
  archiveReason: ArchiveReason,
): Property => ({
  ...property,
  archived_at: archivedAt,
  archive_reason: archiveReason,
  units: property.units.map((unit) =>
    unit.archived_at
      ? unit
      : {
          ...unit,
          effective_archived_at: archivedAt,
          effective_archive_reason: archiveReason,
          archive_source: "PARENT",
        },
  ),
})

export const applyPropertyRestoreState = (property: Property): Property => ({
  ...property,
  archived_at: null,
  archive_reason: null,
  units: property.units.map((unit) =>
    unit.archived_at
      ? {
          ...unit,
          effective_archived_at: unit.archived_at,
          effective_archive_reason: unit.archive_reason,
          archive_source: "SELF",
        }
      : {
          ...unit,
          effective_archived_at: null,
          effective_archive_reason: null,
          archive_source: null,
        },
  ),
})
